import { app } from '@/vendors/firebase/firebase';
import axios from 'axios';

export default {
  async sendEdifactOrder(order) {
    const url = process.env.VUE_APP_EDIFACT_INSERTION_ENDPOINT;
    return axios.post(url,
      order,
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'X-API-KEY': process.env.VUE_APP_X_API_KEY,
          accepts: 'application/json',
          'Content-Type': 'application/json',
          dataType: 'json',
        },
      })
      .then((data) => data)
      .catch((e) => e);
  },

  async incrementsOrderCounter(shopId, countOrder) {
    return app.firestore()
      .collection('shops')
      .doc(shopId)
      .update({ countOrder });
  },
};
